'use client'

import { Caption } from '@material-bank/mb3-components'
import { MbLogo } from '@material-bank/mtag-icons'
import Link from 'next/link'

export function MbLogoLink() {
  return (
    <Link
      href="/"
      title="Material Bank"
      data-testid="mb-logo"
      className="flex items-center gap-2"
    >
      <MbLogo width={32} height={32} />
      <Caption weight="bold" data-testid="mb-logo-title" className="w-min">
        Material Bank
      </Caption>
    </Link>
  )
}
